var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('PrimeiraQuebra',{attrs:{"cases_home":_vm.displayedCases}}),_c('div',{staticClass:"container"},[_c('SobreNos'),_c('Solucoes'),(!_vm.loading)?_c('Cases',{attrs:{"anima_scroll":"-scroll","rodape":true,"cases_home":_vm.cases_home_itens}}):_vm._e(),_c('Manifesto')],1),_c('BlogNews',{staticClass:"margin-manifesto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }